import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { User } from 'src/app/model/user.model';
import { UserService } from 'src/app/service/user.service';
import { AuthService } from 'src/app/service/auth.service';
import { Observable } from 'rxjs';
import { isThursday } from 'date-fns';
import { Location } from '@angular/common';
import { DialogService } from 'src/app/service/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-profile-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {
  user: User;
  userEditForm: FormGroup;
  errorMsg = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private authService: AuthService,
    private location: Location,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.initUser(params.id);
    });
  }

  initUser(id: number) {
    if (id > 0) {
      this.userService.getUserById(id).subscribe(data => {
        this.user = data as User;
        this.initUserEditForm();
      });
    } else {
      this.user = new User();
      this.initUserEditForm();
    }
  }

  initUserEditForm() {
    this.userEditForm = this.formBuilder.group({
      name: [this.user.name, Validators.required],
      lastName: [this.user.lastName, Validators.required],
      username: [this.user.username, Validators.required],
      password: [this.user.password, Validators.required],
      phone: [this.user.phone, Validators.required],
      email: [this.user.email, [Validators.required, Validators.email]]
    });
  }

  save() {
    this.user.name = this.userEditForm.value.name;
    this.user.lastName = this.userEditForm.value.lastName;
    this.user.phone = this.userEditForm.value.phone;
    this.user.email = this.userEditForm.value.email;
    this.userService.editUser(this.user).subscribe(res => {
      this.authService.updateUser(this.user);
      this.location.back();     
    }, error => {
      this.errorMsg = error;
    });
  }

  cancel() {
    this.location.back();
  }
}
